<template>
  <div class="custom-acordeon">
    <div class="accordion" id="accordionInfo">
      <div class="card">
        <div class="card-header" id="headingOne">
          <div class="acordeon-button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" >
            <p>
              ¿ Cuándo debiera seleccionar la nueva prueba
              <span class="black"
                >Electiva de Matemáticas</span
              >
              ?
            </p>
            <img
              src="/images/featured/down-acordeon-arrow.svg"
              alt="down-acordeon-arrow"
            />
          </div>
        </div>

        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionInfo">
          <div class="card-body">
            <p class="initial-text">
              La nueva prueba para el acceso a la Educación
              Superior, PAES, contempla una prueba de
              Matemática Electiva, también conocida como
              Matemática M2. Este curso debe tomarse en
              conjunto con Matemática Obligatoria y es
              especial para quienes deseen estudiar carreras
              ligadas a la Ciencia, Tecnología, Ingeniería o
              Matemática.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="acordeon-separator"></div>
    <div class="accordion" id="accordionInfo2">
      <div class="card">
        <div class="card-header" id="headingTwo">
          <div class="acordeon-button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" >
            <p>
                ¿Cuál es la diferencia entre
                <span class="black">Mención</span> y
                <span class="black">Común</span> en los ramos
                de Ciencias Naturales?
              </p>
            <img
              src="/images/featured/down-acordeon-arrow.svg"
              alt="down-acordeon-arrow"
            />
          </div>
        </div>
        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionInfo2">
          <div class="card-body">
            <p class="initial-text">
              En la prueba de Ciencias Naturales se te
              preguntará materia de Física, Química y
              Biología.

              Es obligación que escojas uno de estos ramos
              como tu ciencia mención, del cual se te
              preguntará una mayor cantidad de contenidos
              
              ya que más del 50% de las preguntas de la
              prueba estarán relacionadas a dicha materia.
              Al tomar la ciencia mención no es necesario
              tomar la misma ciencia en común, ya que la
              mención incluye la totalidad de los contenidos
              de dicho ramo. Los dos ramos restantes
              corresponden a las ciencias comunes, de los
              cuales tendrás que responder una menor
              cantidad de preguntas.
            </p>

            <p class="initial-text mb-0"><b>Ejemplo</b></p>
            <p class="initial-text">
              Biología mención + Física común +Química común
            </p>

            
            <p class="initial-text mb-0"><b>¡Recuerda!</b></p>
            <p class="initial-text">
              Puedes rendir la mención que tu desees, independiente de la carrera que quieras estudiar
            </p>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
  /*.custom-acordeon{
    .acordeon-separator{
      margin-bottom: 32px;
    }

    .accordion{
      border: 2px solid $neutralBlack;
      border-radius: 8px !important;
    }

    .accordion{
      .acordeon-button[aria-expanded="true"] {
        img {
          transform: rotate(0deg);
        }
      }
      .acordeon-button[aria-expanded="false"] {
        img {
          transform: rotate(180deg);
        }
      }
    }

    .card {
      border-radius: 8px !important;
    }

    .card-header{
      background: $amarrillo30;
    }

    .acordeon-button{
      display: flex;
      align-items: center;
      gap: 8px;

      &:hover{
        cursor: pointer;
      }

      p{
        color: $neutralBlack;
        font-family: 'Poppins-Medium', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;

        .black{
          font-family: 'Poppins-Black', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px;
        }
      }

    }

    .initial-text{
      color: $neutralBlack;
      font-family: 'Poppins-Regular', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }

  }*/
</style>